import { Globals } from "./Globals";
import { QRFC } from "./QRFC";
import { QUser } from "./QUser";

export class QUserMgmtRFC extends QRFC {
  constructor() {
    super();
    this.fWSMgr = null;
  }

  InitUserMgmtRFC(wsMgr, callbackObj) {
    this.fWSMgr = wsMgr;
    this.InitRemoteCall(callbackObj ?? this, "POST", true, false);
    this.SetAllowStacked(true);
  }

  SetParams(orgName, userName, mode, data) {
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
  }

  GetCallName() {
    return "qusermgr";
  }

  ChangeUserInfoResult(response) {
    if (response["success"]) {
      if (response["updatedUser"]) {
        // contains obj with key value pairs of updated sections in user
        this.fWSMgr.UpdateUserInfo(response["updatedUser"]);
      }
    }
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    callBackObj.ChangeUserInfoResult(r);
  }

  static UpdateChartRules(wsMgr, newRules) {
    var curOrg = wsMgr.GetAccountName();
    var curUser = wsMgr.GetUserName();

    const userChartRulesInfo = wsMgr.GetUserInfo()?.GetChartRules() || {};

    // We want to do this to avoid delays in UI updates
    wsMgr.GetUserInfo()?.SetChartRules({ ...userChartRulesInfo, ...newRules });

    var updateUserRFC = new QUserMgmtRFC();
    const data = {
      userID: curUser,
      user: [{ chartRules: { ...userChartRulesInfo, ...newRules } }]
    };

    updateUserRFC.InitUserMgmtRFC(wsMgr);
    updateUserRFC.SetParams(curOrg, curUser, "updateUser", JSON.stringify(data));
    Globals._rfcMgr.QueueRFC(updateUserRFC);
  }
}
